import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

// This is the NgRx router store and it is build with the RouterReducerState<any>, so this any is needed to select the store.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectRouterState = createFeatureSelector<RouterReducerState<any>>('router');

export const selectCurrentUrl = createSelector(selectRouterState, (router) => router.state && router.state.url);
